import { gql } from "@apollo/client";

export const GET_CITIES = gql`
  query Cities($province_code: String!) {
    cities(province_code: $province_code) {
      city_name
      city_code
    }
  }
`;

export const GET_BARANGAYS = gql`
  query Barangays($city_code: String!) {
    barangays(city_code: $city_code) {
      brgy_name
      brgy_code
      province_code
      region_code
    }
  }
`;
